import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaInstagram, FaEnvelope, FaPhoneAlt, FaHome, FaInfoCircle, FaCouch, FaUsers, FaBuilding, FaWhatsapp } from "react-icons/fa";
import Logo from "../image/Logo_Nav.webp";
import "../App.css";

export default function Header() {
    const navigate = useNavigate();
    const { pathname } = useLocation();
    const [menuOpen, setMenuOpen] = useState(false);

    useEffect(() => {
        if (menuOpen) {
            const scrollY = window.scrollY;
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.documentElement.style.overflowY = 'scroll';
        } else {
            const scrollY = document.body.style.top;
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.documentElement.style.overflowY = '';
            window.scrollTo(0, parseInt(scrollY || '0') * -1);
        }

        return () => {
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.documentElement.style.overflowY = '';
        };
    }, [menuOpen]);

    return (
        <>
            {/* Top Blue Bar - Scrolls away on scroll */}
            <div className="header-top-bar d-none d-xl-block py-1">
                <div className="container d-flex flex-wrap align-items-center justify-content-between">
                    <div className="top-bar-left">
                        Welcome To Shree Kamdhenu Furniture
                    </div>
                    <div className="top-bar-center d-flex gap-4">
                        <span className="d-flex align-items-center gap-1"><FaEnvelope /> <a href="mailto:kamdhenusteelindustries99@gmail.com" className="text-light text-decoration-none">kamdhenusteelindustries99@gmail.com</a></span>
                        <span className="d-flex align-items-center gap-1"><FaPhoneAlt /> <a href="tel:+917202057575" className="text-light text-decoration-none">+91 72020 57575 <small className="opacity-75">(Customer Care)</small></a></span>
                    </div>
                </div>
            </div>

            {/* Main Navigation Bar - Sticky at top when scrolling */}
            <header className="header-main-nav sticky-top top-0 z-3 bg-white shadow-sm">
                <div className="container d-flex align-items-center justify-content-between">
                    {/* Left: Brand */}
                    <a
                        href="/"
                        onClick={(e) => {
                            if (e.ctrlKey || e.metaKey) return;
                            e.preventDefault();
                            navigate("/");
                        }}
                        className="d-flex align-items-center gap-3 cursor-pointer brand-link py-2"
                    >
                        <img
                            src={Logo}
                            alt="Shree Kamdhenu Furniture"
                            className="header-logo"
                        />
                    </a>

                    {/* Center: Desktop Navigation */}
                    <nav className="nav-center desktop-nav d-none d-xl-flex align-items-center">
                        <Link to="/" className={`nav-link ${pathname === '/' ? 'active' : ''}`}>Home</Link>
                        <Link to="/collections" className={`nav-link ${pathname === '/collections' ? 'active' : ''}`}>Our Products</Link>
                        <Link to="/about" className={`nav-link ${pathname === '/about' ? 'active' : ''}`}>About Us</Link>
                        <Link to="/clients" className={`nav-link ${pathname === '/clients' ? 'active' : ''}`}>Our Clients</Link>
                        <Link to="/infrastructure" className={`nav-link ${pathname === '/infrastructure' ? 'active' : ''}`}>Project Gallery</Link>
                        <Link to="/contact" className={`nav-link ${pathname === '/contact' ? 'active' : ''}`}>Contact Us</Link>
                    </nav>

                    {/* Right: Inquiry Button & Socials */}
                    <div className="nav-right d-none d-xl-flex align-items-center gap-3">
                        {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="nav-social-icon"><FaFacebookF /></a> */}
                        <a href="https://www.instagram.com/kamdhenusteelindustries1995/" target="_blank" rel="noopener noreferrer" className="nav-social-icon"><FaInstagram /></a>
                        <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="nav-social-icon" title="Chat on WhatsApp"><FaWhatsapp /></a>
                        <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="btn btn-primary btn-inquiry">Inquiry Now &rarr;</a>
                    </div>

                    {/* Mobile Menu Button */}
                    <button
                        className={`mobile-menu-btn creative-hamburger d-xl-none ${menuOpen ? 'open' : ''}`}
                        onClick={() => setMenuOpen(!menuOpen)}
                        aria-label="Toggle menu"
                    >
                        <span></span>
                        <span></span>
                        <span></span>
                    </button>
                </div>

                {/* Mobile Nav Overlay (Sidebar) */}
                <div className={`mobile-nav-backdrop ${menuOpen ? 'show' : ''}`} onClick={() => setMenuOpen(false)}></div>
                <div className={`mobile-nav-overlay gap-0 ${menuOpen ? 'open' : ''}`}>
                    <div className="mobile-sidebar-header px-3 py-2 border-bottom d-flex align-items-center justify-content-between">
                        <img src={Logo} alt="Shree Kamdhenu Furniture" style={{ height: '70px' }} />
                        <button className="btn-close" onClick={() => setMenuOpen(false)} aria-label="Close"></button>
                    </div>
                    <div className="px-3 py-2 bg-light text-center border-bottom text-muted" style={{ fontSize: '13px', fontWeight: '500' }}>
                        Welcome To Shree Kamdhenu Furniture
                    </div>
                    <div className="d-flex flex-column gap-1 p-3">
                        <Link to="/" className={`mobile-nav-link ${pathname === '/' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaHome className="nav-icon" /> HOME</Link>
                        <Link to="/about" className={`mobile-nav-link ${pathname === '/about' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaInfoCircle className="nav-icon" /> ABOUT US</Link>
                        <Link to="/collections" className={`mobile-nav-link ${pathname === '/collections' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaCouch className="nav-icon" /> OUR PRODUCTS</Link>
                        <Link to="/clients" className={`mobile-nav-link ${pathname === '/clients' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaUsers className="nav-icon" /> OUR CLIENTS</Link>
                        <Link to="/infrastructure" className={`mobile-nav-link ${pathname === '/infrastructure' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaBuilding className="nav-icon" /> OUR INFRASTRUCTURE</Link>
                        <Link to="/contact" className={`mobile-nav-link ${pathname === '/contact' ? 'active' : ''}`} onClick={() => setMenuOpen(false)}><FaEnvelope className="nav-icon" /> CONTACT US</Link>
                    </div>
                    <div className="mobile-sidebar-footer p-3 bg-light mt-auto border-top">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h6 className="fw-bold mb-0 text-dark" style={{ fontSize: '14px' }}>Get in Touch</h6>
                            <div className="d-flex gap-2">
                                {/* <a href="https://facebook.com" target="_blank" rel="noopener noreferrer" className="nav-social-icon shadow-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', fontSize: '12px', background: '#fff', borderRadius: '50%' }}><FaFacebookF /></a> */}
                                <a href="https://www.instagram.com/kamdhenusteelindustries1995/" target="_blank" rel="noopener noreferrer" className="nav-social-icon shadow-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', fontSize: '12px', background: '#fff', borderRadius: '50%' }}><FaInstagram /></a>
                                <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="nav-social-icon shadow-sm d-flex align-items-center justify-content-center" style={{ width: '28px', height: '28px', fontSize: '12px', background: '#fff', borderRadius: '50%' }} title="Chat on WhatsApp"><FaWhatsapp /></a>
                            </div>
                        </div>
                        <div className="d-flex flex-column gap-2 text-muted small mb-3">
                            <span className="d-flex align-items-center gap-2"><FaEnvelope className="text-primary" /> <a href="mailto:kamdhenusteelindustries99@gmail.com" className="text-muted text-decoration-none">kamdhenusteelindustries99@gmail.com</a></span>
                            <span className="d-flex align-items-center gap-2"><FaPhoneAlt className="text-primary" /> <a href="tel:+917202057575" className="text-muted text-decoration-none">+91 72020 57575 (Customer Care)</a></span>
                        </div>
                        <a href="https://wa.me/919924382499?text=Hello!%20I%20would%20like%20to%20inquire%20about%20Shree%20Kamdhenu%20Furniture." target="_blank" rel="noopener noreferrer" className="btn btn-primary w-100 rounded-pill py-1 shadow-sm d-flex justify-content-center align-items-center gap-2" style={{ fontSize: '14px', letterSpacing: '0.5px' }}>
                            Inquiry Now &rarr;
                        </a>
                    </div>
                </div>
            </header>
        </>
    );
}
